import React, { useContext, useEffect, useState } from "react";
import InputRegister from "../../blocks/ui/InputDesign";
import { IoClose } from "react-icons/io5";
import { DContext } from "../../../context/Datacontext";
import {
    createStatus,
    fetchStatusId,
    updateStatus,
} from "../../services/managerApi/statusApi";

export default function Status({ statusView, setStatusView, statusId }) {
    const { BeURL, showAlert } = useContext(DContext);

    const [status, setStatus] = useState({
        group: "",
        status: "",
        isActive: true,
    });

    const [errors, setErrors] = useState({
        group: "",
        status: "",
    });

    const groups = [
        "Screening",
        "Level 1 Interview",
        "Level 2 Interview",
        "Level 3 Interview",
        "BGV",
        "Offer Status",
        "Drop",
        "Client Round"
    ];

    useEffect(() => {
        if (statusId) {
            fetchStatusId(BeURL, showAlert, setStatus, statusId);
        }
    }, [statusId]);


    const handleStatus = (name, value, checked) => {
        const finalValue = name === "isActive" ? checked : value;

        setStatus((prev) => ({
            ...prev,
            [name]: finalValue,
        }));

        if (name !== "isActive") {
            setErrors((prev) => ({
                ...prev,
                [name]: finalValue.trim() ? "" : "This field is required",
            }));
        }
    };

    const validateForm = () => {
        const newErrors = {
            group: status.group ? "" : "Group is required",
            status: status.status ? "" : "Status is required",
        };

        setErrors(newErrors);

        return Object.values(newErrors).every((err) => err === "");
    };

    const handleCreate = async () => {
        if (!validateForm()) return;

        const payload = {
            group: status.group,
            type: status.status,
            isActive: status.isActive,
        };

        console.log(payload);

        await createStatus(BeURL, showAlert, payload, setStatus);

        setStatus({
            group: "",
            status: "",
            isActive: true,
        });

        setStatusView(false);
    };

    const handleUpdate = async () => {
        if (!validateForm()) return;

        const payload = {
            group: status.group,
            status: status.status,
            isActive: status.isActive,
        };

        await updateStatus(
            BeURL,
            showAlert,
            payload,
            setStatus,
            statusId
        );

        setStatusView(false);
    };

    return (
        <>
            {statusView && (
                <div className="fixed inset-0 z-50 bg-black/30 flex items-center justify-center">
                    <div className="bg-white rounded-xl shadow-lg w-full max-w-lg m-2">

                        {/* Header */}
                        <div className="flex justify-between items-center border-b p-5">
                            <h2 className="text-xl font-semibold text-primary-500">
                                {statusId ? "Update Status" : "Create Status"}
                            </h2>

                            <IoClose
                                className="text-2xl cursor-pointer"
                                onClick={() => setStatusView(false)}
                            />
                        </div>

                        {/* Body */}
                        <div className="p-5 space-y-5">

                            {/* Group */}
                            <div>
                                <label className="block mb-1 font-medium">
                                    Group <span className="text-red-500">*</span>
                                </label>

                                <select
                                    name="group"
                                    value={status.group}
                                    onChange={(e) => handleStatus(e.target.name, e.target.value)}
                                    className="w-full border rounded-lg p-3"
                                >
                                    <option value="">Select Group</option>

                                    {groups.map((item, index) => (
                                        <option key={index} value={item}>
                                            {item}
                                        </option>
                                    ))}
                                </select>

                                {errors.group && (
                                    <p className="text-red-500 text-sm mt-1">
                                        {errors.group}
                                    </p>
                                )}
                            </div>

                            {/* Status */}
                            <InputRegister
                                label="Status Name"
                                name="status"
                                value={status.status}
                                placeholder="Enter Status Name"
                                required
                                error={errors.status}
                                onChange={(e) =>
                                    handleStatus(e.target.name, e.target.value)
                                }
                            />

                            {/* Hints */}

                            {status.group === "BGV" && (
                                <div className="bg-yellow-100 text-yellow-800 text-xs rounded-lg p-2">
                                    Valid Formats:
                                    <br />
                                    • BGV Inprogress
                                    <br />
                                    • BGV Green
                                    <br />
                                    • BGV Amber
                                    <br />
                                    • BGV Red
                                </div>
                            )}

                            {status.group === "Screening" &&
                                status.status.toLowerCase().includes("eval") && (
                                    <div className="bg-yellow-100 text-yellow-800 text-xs rounded-lg p-2">
                                        Valid Format:
                                        <br />
                                        • Waiting For Evaluation
                                    </div>
                                )}

                            {/* Active */}
                            <div className="flex items-center gap-3">
                                <input
                                    type="checkbox"
                                    name="isActive"
                                    checked={status.isActive}
                                    onChange={(e) =>
                                        handleStatus(
                                            e.target.name,
                                            e.target.value,
                                            e.target.checked
                                        )
                                    }
                                />

                                <label>Active</label>
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="border-t p-5 flex justify-end gap-3">

                            <button
                                onClick={() => setStatusView(false)}
                                className="px-5 py-2 rounded-lg border"
                            >
                                Cancel
                            </button>

                            <button
                                onClick={
                                    statusId
                                        ? handleUpdate
                                        : handleCreate
                                }
                                className="px-6 py-2 rounded-lg bg-primary-500 text-white hover:bg-primary-600"
                            >
                                {statusId
                                    ? "Update"
                                    : "Save"}
                            </button>

                        </div>
                    </div>
                </div>
            )}
        </>
    );
}